// Area center coordinates for zooming
export const areaCenters = {
  'P02 Rogaland': { lat: 59.20, lng: 5.90, zoom: 9 },
  'P03 Hordaland/NFN': { lat: 60.04, lng: 5.40, zoom: 8.3 },
  'P03 Hordaland': { lat: 60.04, lng: 5.40, zoom: 8.3 },
  'P03/NFN': { lat: 60.04, lng: 5.40, zoom: 8.3 },
  'P01 Vestland': { lat: 60.39, lng: 5.32, zoom: 9 },
  'P03 Møre og Romsdal': { lat: 62.47, lng: 6.15, zoom: 9 },
  'P04 Trøndelag': { lat: 63.43, lng: 10.39, zoom: 9 },
  'P04 Sogn': { lat: 61.20, lng: 6.50, zoom: 9 },
  'P04 Nordfjord': { lat: 61.80, lng: 5.80, zoom: 9 },
  'P04 YSSF/FHN': { lat: 61.30, lng: 5.30, zoom: 8.5 },
  'P04 YSSF': { lat: 61.30, lng: 5.30, zoom: 8.5 },
  'P05 Nordland': { lat: 67.28, lng: 14.40, zoom: 8 },
  'P06 Troms': { lat: 69.65, lng: 18.96, zoom: 8 },
  'P07 Finnmark': { lat: 70.07, lng: 25.00, zoom: 8 },
  'all': { lat: 60.0, lng: 6.5, zoom: 7 }
};

// Location coordinates - all areas
export const locationCoordinates = {
  // P02 Rogaland
  'Toftøy': { lat: 59.270767, lng: 5.691433 },
  'Føresvik': { lat: 59.249767, lng: 5.438233 },
  'Rosshl.': { lat: 59.051467, lng: 5.708867 },
  'Høgsfj.': { lat: 58.95365, lng: 5.96495 },
  'Finnøyfj.': { lat: 59.139017, lng: 5.86905 },
  'Årdalsfj.': { lat: 59.133917, lng: 6.040017 },
  'Jøsenfj.': { lat: 59.2746, lng: 6.244283 },
  'Erfj.': { lat: 59.311383, lng: 6.151933 },
  'Jelsa': { lat: 59.365433, lng: 6.01545 },
  'Vindafj.': { lat: 59.460917, lng: 5.950133 },
  'Rott': { lat: 58.953383, lng: 5.51905 },
  'Boknafj.': { lat: 59.150617, lng: 5.51545 },
  // P03 Hordaland/NFN
  'Sletto': { lat: 59.484722, lng: 5.151944 },
  'Bømlo V': { lat: 59.718777, lng: 5.051916 },
  'Stokksund': { lat: 59.775888, lng: 5.352019 },
  'Selbjørnsfjorden': { lat: 59.989444, lng: 5.288888 },
  'Austevoll V': { lat: 60.051972, lng: 5.130277 },
  'Sotra V': { lat: 60.227916, lng: 4.916116 },
  'Hjeltefjorden': { lat: 60.439643, lng: 5.033875 },
  'Herdlafjorden': { lat: 60.520673, lng: 5.145113 },
  'Øygarden, Sauøy': { lat: 60.598298, lng: 4.8732 },
  'Sørfjorden': { lat: 60.488725, lng: 5.429898 },
  'Fusafjorden': { lat: 60.212229, lng: 5.569459 },
  'Bjørnafjorden, Malkenes': { lat: 60.092106, lng: 5.682069 },
  'Sildafjorden': { lat: 60.104772, lng: 6.087533 },
  'Ytre Samlafjorden': { lat: 60.327664, lng: 6.261941 },
  'Husnesfjorden': { lat: 59.85675, lng: 5.657349 },
  'Skåneviksfjorden': { lat: 59.768967, lng: 5.906945 },
  'Ytre Ålfjord': { lat: 59.710576, lng: 5.560532 },
  // P04 YSSF/FHN
  'Kuøyna': { lat: 60.999361, lng: 4.894409 },
  'Olderøy': { lat: 61.11175, lng: 4.701104 },
  'Klubben': { lat: 61.192289, lng: 5.006301 },
  'Kalvøy': { lat: 61.331886, lng: 4.71092 },
  'Svinøy': { lat: 61.317491, lng: 5.095754 },
  'Klavelandet': { lat: 61.607032, lng: 5.176214 },
  'Måren': { lat: 61.1601, lng: 6.104373 },
};

// Risk configuration for map markers
export const riskConfig = {
  normal: { 
    color: '#10b981', 
    label: 'Låg', 
    bgClass: 'bg-emerald-500', 
    borderColor: 'border-emerald-400', 
    textColor: 'text-emerald-700', 
    lightBg: 'bg-emerald-50',
    markerColor: '#10b981',
    icon: '✓'
  },
  low: { 
    color: '#10b981', 
    label: 'Grøn', 
    bgClass: 'bg-emerald-500', 
    borderColor: 'border-emerald-400', 
    textColor: 'text-emerald-700', 
    lightBg: 'bg-emerald-50',
    markerColor: '#10b981',
    icon: '✓'
  },
  elevated: {
    color: '#eab308',
    label: 'Gul',
    bgClass: 'bg-yellow-300',
    borderColor: 'border-yellow-300',
    textColor: 'text-yellow-600',
    lightBg: 'bg-yellow-50',
    markerColor: '#eab308',
    icon: '⚠'
  },
  medium: { 
    color: '#fb923c', 
    label: 'Oransje', 
    bgClass: 'bg-orange-400', 
    borderColor: 'border-orange-300', 
    textColor: 'text-orange-700', 
    lightBg: 'bg-orange-50',
    markerColor: '#fb923c',
    icon: '⚠'
  },
  warning: {
    color: '#fb923c',
    label: 'Oransje',
    bgClass: 'bg-orange-400',
    borderColor: 'border-orange-300',
    textColor: 'text-orange-700',
    lightBg: 'bg-orange-50',
    markerColor: '#fb923c',
    icon: '⚠'
  },
  high: { 
    color: '#ef4444', 
    label: 'Raud', 
    bgClass: 'bg-red-500', 
    borderColor: 'border-red-400', 
    textColor: 'text-red-700', 
    lightBg: 'bg-red-50',
    markerColor: '#ef4444',
    icon: '⚠'
  },
  critical: { 
    color: '#ef4444', 
    label: 'Raud', 
    bgClass: 'bg-red-500', 
    borderColor: 'border-red-400', 
    textColor: 'text-red-700', 
    lightBg: 'bg-red-50',
    markerColor: '#ef4444',
    icon: '⚠'
  }
};

export const CHART_COLORS = ['#0ea5e9', '#8b5cf6', '#ec4899', '#f97316', '#10b981', '#6366f1'];

// Get risk level from color string (green, yellow, orange, red)
export const getRiskLevelFromColor = (color) => {
  if (color === 'red') return 'high';
  if (color === 'orange') return 'warning';
  if (color === 'yellow') return 'elevated';
  return 'low';
};

// Get risk level from value and thresholds
export const getRiskLevel = (value, thresholds) => {
  if (!thresholds) return 'normal';
  
  const val = parseFloat(value) || 0;
  if (val >= thresholds.red) return 'critical';
  if (val >= thresholds.orange) return 'warning';
  if (val >= thresholds.yellow) return 'elevated';
  return 'normal';
};

// Get color based on value and thresholds
export const getColorForValue = (value, thresholds) => {
  if (!thresholds) return '#10b981'; // Default green
  
  const val = parseFloat(value);
  if (val < thresholds.yellow) return '#10b981'; // Green
  if (val < thresholds.orange) return '#eab308'; // Sitron yellow
  if (val < thresholds.red) return '#fb923c'; // Lys orange
  return '#ef4444'; // Red
};
